import { createSlice } from '@reduxjs/toolkit';


const initialState = { ready:true, swap:false, selectedTiles:[], tilesStatus:{}, isComplete:false };
const swapPuzzleSlice = createSlice({
    name: 'swapPuzzleSlice',
    initialState,
    reducers: {
        start: (state) => {
            return {...state, ready:false, isComplete:false, tilesStatus:{}};
        },
        end: (state) => initialState,
        selectTiles: (state, action) => {
            return {...state, selectedTiles:[...state.selectedTiles, action.payload]};
        },
        unselectTiles: (state,action) => {
            const coords = action.payload;
            return {...state, selectedTiles: state.selectedTiles.filter(tile=>!tile.every((coord, index) => coord===coords[index])) };
        },
        resetSelectTiles: (state) => {
            return { ...state, swap: false, tiles: [] };
        },
        swapTiles: (state) => {
            return { ...state, swap: true };
        },
        updateTileStatus: (state, action) => {
            return {
                ...state,
                tilesStatus: {
                  ...state.tilesStatus,
                  [action.payload.id]: action.payload.status
                }
              };
        }
    }
});


export default swapPuzzleSlice.reducer;
export const swapPuzzleActions = swapPuzzleSlice.actions;


export function setSelectedTile(coords){
    return function(dispatch){
        dispatch( swapPuzzleActions.selectTiles(coords) );
    }
}

export function removeSelectedTile(coords){
    return function(dispatch){
        dispatch( swapPuzzleActions.unselectTiles(coords) );
    }
}

export function resetSwapTile(){
    return function(dispatch){
        dispatch( swapPuzzleActions.resetSelectTiles() );
    }
}

export function swapTiles(){
    return function(dispatch){
        dispatch( swapPuzzleActions.swapTiles() );
    }
}

export function setTileStatus(statusData){
    return function(dispatch){
        dispatch( swapPuzzleActions.updateTileStatus(statusData) );
    }
}

export function startGame(){
    return function(dispatch){
        dispatch( swapPuzzleActions.start() );
    }
}

export function endGame(){
    return function(dispatch){
        dispatch( swapPuzzleActions.end() );
    }
}